import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalService, ProfileService, StoreService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-welcomepage',
  templateUrl: './welcomepage.component.html',
  styleUrls: ['./welcomepage.component.scss']
})
export class WelcomepageComponent implements OnInit {
  userData:any;
   dataToken="";
  dataName:any;
  tokenData:boolean=false;
  pamProgressData:any;
  createProfileModalOpen: boolean = false;

  constructor(
    private profileser: ProfileService,
    private router: Router,
    private popupMessageService: PopupMessageService,
    private storeService: StoreService,
    private route: ActivatedRoute
  ) { }

  openDialog() {
    this.createProfileModalOpen = true;
  }

  closeCreateProfileModal() {
    this.createProfileModalOpen = false;
  }

  onCreateProfileContinue() {
    this.createProfileModalOpen = false;
    this.updateWelecomepage('profile', true);
  }
  ngOnInit() {
    this.userData=LocalService.get('userProfile');
   // this.getDataToken();
    this.getPamActivityData();
    this.getpamActivityProgress();
  }
  
  visitPTMClicked:boolean=false;
  ReviewOverviewClicked:boolean=false;
  CreateProfleClicked:boolean=false;
  pamActivityData:any;

  updateWelecomepage(data: any, flag: any){
    if(data=='visitPTM'){
      this.visitPTMClicked=flag;
    }else if(data=='reviewOverview'){
      this.ReviewOverviewClicked=flag;
    }else if(data=='profile'){
      this.CreateProfleClicked=flag;
    }
    let reqPrm: any = {};
    reqPrm = 'username=' + this.userData.username +
      '&visitPTMClicked=' + this.visitPTMClicked +
      '&ReviewOverviewClicked=' + this.ReviewOverviewClicked +
      '&CreateProfleClicked=' + this.CreateProfleClicked;
    this.profileser.updateWelecomePageData(reqPrm).subscribe((res: any)=>{
      if(res!=null){
        this.pamActivityData=res;
        this.getpamActivityProgress();
        // if(this.ReviewOverviewClicked==true||this.visitPTMClicked==true){
        //   window.location.reload();
        // }
        if(this.CreateProfleClicked){

          const pamRe=res;
          this.userData.pamActivity=pamRe;
          this.storeService.setUserObj(this.userData);
          LocalService.set('userProfile',this.userData ); 
          return this.router.navigateByUrl('/profile');
        }
        
      }
    })
  }
  htmlData:any;
  getDataToken(){
    
  
    
  const token = this.route.snapshot.data['pamData'];
  this.dataToken=token.accessToken;
  // this.dataName=pamuserdev47;

  this.tokenData=true;
   // console.log('token',token);


const script2 = document.getElementById("bunchballTrophy");

if (script2) {
  script2.setAttribute('data-user-id', token.userName);
  script2.setAttribute('data-token', token.accessToken);
}

document.querySelectorAll('bunchball-missions')
          .forEach((function(x: any){
            x.setAttribute('data-user-id',token.userName);
          x.setAttribute("data-token", token.accessToken);
         }))

const script = document.createElement("script");
script.type = "text/javascript";
script.src = "https://widgets.bunchball.net/web/latest/component.min.js";
document.getElementsByTagName("head")[0].appendChild(script);
  }



 

  reviewOverviewClicked(data: any, flag: any){
    this.updateWelecomepage(data,flag);
    window.open("https://www.cisco.com/c/dam/en/us/products/se/2020/3/Collateral/sr-blackbelt2-se-challenges-terms-la.pdf");

  }

  visitPtmClicked(data: any, flag: any){
    this.updateWelecomepage(data,flag);
    window.open("http://pdm.cloudapps.cisco.com/ptm");
  }

// Function to check which link has clicked
getPamActivityData(){
  this.profileser.getWelecomePageData(this.userData.username).subscribe((data: any)=>{
    this.pamActivityData=data;
    if(data.createProfleClicked){
      return this.router.navigateByUrl('/profile');
    }
  })
}
// get pam activity earned date
getpamActivityProgress(){
  this.profileser.getpamActivityProgress(this.userData.username).subscribe((data: any)=>{
    this.pamProgressData=data;
  })
}

get completedCount(): number {
  if (!this.pamActivityData) { return 0; }
  let count = 0;
  if (this.pamActivityData.visitPtmClicked) { count++; }
  if (this.pamActivityData.reviewOverviewClicked) { count++; }
  if (this.pamActivityData.createProfleClicked) { count++; }
  return count;
}

get userInitials(): string {
  if (!this.userData) { return 'PA'; }
  const name = this.userData.name || this.userData.username || '';
  if (!name) { return 'PA'; }
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}
}
